import {
  FullScreenMessage,
  ModalMessage,
  showInAppMessage,
  subscribeToInAppMessage,
} from "@braze/web-sdk";
import { EnvironmentNames } from "@origin-digital/platform-enums";
import { logger } from "@origin-digital/reporting-client";

import { BRAZE_ID, DASHBOARD_PATHNAME } from "../utils/config";
import { configureButtons, overwriteButtonAction } from "./buttons";
import { brazeIAMStyle } from "./inAppMessageStyles";

export const configureMessage = (
  inAppMessage: ModalMessage | FullScreenMessage
) => {
  inAppMessage.htmlId = BRAZE_ID;

  const { buttons, extras } = inAppMessage;

  // turn off any buttons with navTo. or navClose.
  if (buttons) {
    const replacementButtons = configureButtons(buttons);
    inAppMessage.buttons = replacementButtons;
  }

  // iframed survey detection - unable to confirm type
  if (extras && extras.style === "oe-style") {
    inAppMessage.css = brazeIAMStyle;
  }
};

export const inAppMessageInit = (
  environment: EnvironmentNames,
  path: string
) => {
  // Restrict InAppMessage to Dashboard (except for local dev)
  if (path === DASHBOARD_PATHNAME || environment === "local") {
    subscribeToInAppMessage((inAppMessage) => {
      // configure before show
      configureMessage(inAppMessage as ModalMessage | FullScreenMessage);
      // braze call to show message
      showInAppMessage(inAppMessage);
      // configure after show
      overwriteButtonAction(inAppMessage as ModalMessage | FullScreenMessage);
      logger.debug("[braze] subscribeToInAppMessage", inAppMessage);
    });
  }
};
